import request from "@/utils/request1";
import baseURL from "@/utils/baseUrl1";
//import fileRequest from "@/utils/fileRequest";


const queryConditionService = {};

/**
 *字典数据
 */
queryConditionService.getDictData= function (params) {
    return request({
        url: "/fruitPublish/public/showDataDict",
        method: "get",
		params:params,
        baseURL: baseURL.platformNotAuth,
        headers: {
            "Content-Type": "application/json; charset=UTF-8"
        }
    });
}
/**
 *是否登录
 */
queryConditionService.isLogin= function (params) {
    return request({
        url: "/user/my/q/simpleinfo?_=" + Date.now(),
        method: "get",
		params:params,
        baseURL: baseURL.userBase,
        headers: {
            "Content-Type": "application/json; charset=UTF-8"
        }
    });
}
/**
 *成果转化分页查询
 */
queryConditionService.fruitTransferList= function (params) {
    return request({
        url: "/fruitPublish/public/getPaginList",
        method: "post",
		data:params,
        baseURL: baseURL.platformNotAuth,
        headers: {
            "Content-Type": "application/json; charset=UTF-8"
        }
    });
}
/**
 *成果转化详情
 */
queryConditionService.fruitTransferDetail= function (params) {
    return request({
        url: "/fruitPublish/public/showDetail",
        method: "get",
		params:params,
        baseURL: baseURL.platformNotAuth,
        headers: {
            "Content-Type": "application/json; charset=UTF-8"
        }
    });
}

/**
 *查询条件-年份列表
 */
queryConditionService.yearList= function () {
    return request({
        url: "/analysis/queryCondition/yearList",
        method: "post",
        baseURL: baseURL.platform,
        headers: {
            "Content-Type": "application/json; charset=UTF-8"
        }
    });
}
/**
 *平台详情
 */
queryConditionService.platformDetail= function (params) {
    return request({
        url: "/platform/platformDetail",
        method: "get",
		params:params,
        baseURL: baseURL.platform,
        headers: {
            "Content-Type": "application/json; charset=UTF-8"
        }
    });
}

/**
 *验证1
 */
queryConditionService.finishDetail= function (projectId) {
    return request({
        url: "/finish/manage/query-certification-detail",
        method: "get",
		params:{projectId: projectId},
        baseURL: '/uoc/finish-api',
        headers: {
            "Content-Type": "application/json; charset=UTF-8"
        }
    });
}

/**
 *验证2
 */
queryConditionService.establishDetail= function (projectId) {
    return request({
        url: "/project-declare/query-participant-unit-person",
        method: "get",
		params:{projectId: projectId},
        baseURL: '/uoc/establish-api',
        headers: {
            "Content-Type": "application/json; charset=UTF-8"
        }
    });
}

/**
 *科管系统导出
 */
queryConditionService.downloadFile = function (params, fileName) {
    return fileRequest({
        url: "/projectTypeCount/export",
        method: "post",
        data:params,
        baseURL: baseURL.platform,
        headers: {
            "Content-Type": "application/json; charset=UTF-8"
        }
    }).then(res => {
        if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(res, fileName)
        } else {
            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(new Blob([res]));
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href)
        }
    }).catch(res => {
        return Promise.reject(res);
    });
}


export default queryConditionService;